import { Dayjs } from 'dayjs';

export const convertDayjsToApiFormat = (date: Dayjs) => date.format('YYYY-MM-DD') + ' 12:00:00';

export const convertDayjsDatetimeToApiFormat = (date: Dayjs) => date.toISOString();

export const dayJsToApiDatetime = (date: Dayjs) => date.toISOString();
